// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3-uTo","footer":"ModalFilter_footer__3ueWB"};